"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _MenuList.default;
  }
});

var _MenuList = _interopRequireDefault(require("./MenuList"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/MenuList/index.js
// module id = 342
// module chunks = 0